// Title, description, canonical and Open Graph tags are written by each
// route's head() (server HTML). This component only renders optional JSON-LD.
interface SEOHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  schema?: React.ReactNode;
  ogType?: "website" | "article";
}

export const SEOHead = ({ schema }: SEOHeadProps) => {
  return <>{schema}</>;
};
